import { GfxControllerIdentifier } from '@blocksuite/affine/std/gfx';
import type * as Y from 'yjs';

import type { AffineEditorContainer } from './blocksuite-editor';
import type { AnnotationTarget } from './object-annotation-store';

export function resolveAnnotationTarget(
  editor: AffineEditorContainer,
  id: string
): AnnotationTarget | null {
  const block = editor.doc.getBlock(id)?.model;
  if (block)
    return {
      id,
      kind: block.flavour.replace('affine:', ''),
      name:
        String(block.yBlock.get('prop:title') ?? block.text ?? '').slice(
          0,
          80
        ) || block.flavour.replace('affine:', ''),
      data: block.yBlock as unknown as Y.Map<unknown>,
    };
  const element = editor.std
    ?.getOptional(GfxControllerIdentifier)
    ?.getElementById(id);
  if (element && 'yMap' in element) {
    const data = element.yMap as Y.Map<unknown>;
    return {
      id,
      kind: String(data.get('type') ?? 'object'),
      name: String(
        data.get('text') ??
          data.get('shapeType') ??
          data.get('type') ??
          'Object'
      ).slice(0, 80),
      data,
    };
  }
  return null;
}
